function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.524 1.124a.5.5 0 01.952 0l2.13 6.647a1.5 1.5 0 001.429 1.042h6.921a.5.5 0 01.297.903l-5.624 4.142a1.5 1.5 0 00-.538 1.666l2.142 6.685a.5.5 0 01-.773.555l-5.57-4.104a1.5 1.5 0 00-1.78 0l-5.57 4.104a.5.5 0 01-.773-.555l2.142-6.685a1.5 1.5 0 00-.538-1.666L.747 9.716a.5.5 0 01.297-.903h6.921a1.5 1.5 0 001.429-1.042l2.13-6.647z",
  stroke: "#E7E6EC"
});

var SvgEmptyStar = function SvgEmptyStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgEmptyStar;